import Grid from 'admin/components/atoms/Grid';
import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import { getAccountExpiredBalances } from '~/javascripts/admin/actions/account';
import { toQueryParams } from '~/javascripts/admin/utils';
import { toPointExpiresAtFormValue } from '~/javascripts/admin/utils/pointExpiry';
import Pager from '../../../molecules/Pager';

const GridRow = styled(Grid.Container)`
  padding: 6px 0;
`;

const PagerWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 6px;
`;

const AmountBlock = styled.div`
  min-width: 6em;
  text-align: right;
`;

const UnitBlock = styled.div`
  width: 1em;
  text-align: right;
  display: inline-block;
`;

const ExpiredBalances = ({ accountId }: { accountId?: string }) => {
  const [expiredBalances, setExpiredBalances] =
    useState<Awaited<ReturnType<typeof getAccountExpiredBalances>>>();

  const getExpiredBalances = useCallback(
    (page = 1) => {
      if (accountId) {
        getAccountExpiredBalances(accountId, toQueryParams({ page, per_page: 50 })).then((res) =>
          setExpiredBalances(res)
        );
      }
    },
    [accountId]
  );

  const onChangePage = (page: number) => {
    getExpiredBalances(page);
  };

  useEffect(() => {
    getExpiredBalances();
  }, [accountId, getExpiredBalances]);

  if (!expiredBalances?.rows?.length) {
    return null;
  }

  return (
    <>
      {expiredBalances.rows.map(({ expires_at, money_amount, point_amount }) => (
        <>
          <GridRow key={expires_at}>
            <Grid.Item size={3}>
              {toPointExpiresAtFormValue(expires_at)?.format('YYYY/MM/DD')}
            </Grid.Item>
            <Grid.Item size={9}>
              {[
                { amount: money_amount, unit: '円' },
                { amount: point_amount, unit: 'P' },
              ]
                .filter((i) => !!i.amount)
                .map(({ amount, unit }) => (
                  <AmountBlock>
                    {amount?.toLocaleString()} <UnitBlock>{unit}</UnitBlock>
                  </AmountBlock>
                ))}
            </Grid.Item>
          </GridRow>
          <Grid.Divider margin="0" />
        </>
      ))}

      <PagerWrapper>
        <Pager pagination={expiredBalances.pagination} onChangePage={onChangePage} />
      </PagerWrapper>
    </>
  );
};

export default ExpiredBalances;
